import { useEffect, useState } from 'react';

import { settings } from '@/settings';
import { createLogger } from '@/utils';

import { axiosInstance } from './axiosInstance';

const log = createLogger('useSsoLoginUrl');

type SsoResponse = { login_url: string | null };

/** Absolute URL that starts SSO and returns to `nextUrl`, or `null` when SSO is disabled */
export const useSsoLoginUrl = (nextUrl: string) => {
  const [loginUrl, setLoginUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    axiosInstance
      .get<SsoResponse>(settings.SSO_URL)
      .then(({ data }) => {
        if (active) setLoginUrl(data.login_url);
      })
      .catch((error: unknown) => log('SSO unavailable %o', error));
    return () => {
      active = false;
    };
  }, []);

  if (!loginUrl) return null;

  const params = new URLSearchParams({ next: nextUrl });
  return `${settings.BASE_API_ORIGIN}${loginUrl}?${params}`;
};
